import { InjectionToken } from '@angular/core';
import { AuthConfig } from '../../types/auth-config';

export const AUTH_MODULE_CONFIG = new InjectionToken<AuthConfig>(
  'AUTH_MODULE_CONFIG'
);
